<script>
import ContentsWithLinks from "@/components/article/politiken/ContentsWithLinks.vue";

export default {
  name: "ArticleMeaningWordConnections",
  components: { ContentsWithLinks },
  props: {
    definitions: {
      type: Array,
      required: true
    },
    definitionExtensions: {
      type: Array,
      required: true
    },
    showHeader: {
      type: Boolean,
      required: true
    },
    sublemmaOne: {
      type: String,
      required: true
    },
    sublemmaNumber: {
      type: String,
      required: true
    },
    rComment: {
      type: String,
      required: true
    },
    fComment: {
      type: String,
      required: true
    }
  },
  computed: {
    definitionClass() {
      return "article-content__text article-content__text--primary";
    }
  }
};
</script>

<template>
  <div
    v-if="
      sublemmaOne.length > 0 ||
      definitions.length > 0 ||
      definitionExtensions.length > 0 ||
      rComment.length > 0 ||
      fComment.length > 0
    "
  >
    <div
      v-if="rComment.length > 0"
      class="d-inline article-content__text article-content__text--primary pr-2"
      v-html="rComment"
    ></div>
    <div
      v-if="fComment.length > 0"
      class="d-inline article-content__text article-content__text--primary pr-2"
      v-html="fComment"
    ></div>
    <div
      v-if="sublemmaOne"
      class="d-inline article-content__text article-content__text--primary article-content__text--prominent pr-2"
    >
      <span v-html="sublemmaOne"></span>
      <sup v-if="sublemmaNumber"> {{ sublemmaNumber }}</sup>
    </div>
    <template v-if="definitions.length > 0">
      <div
        v-for="(definition, definitionIndex) in definitions"
        :key="`${definitionIndex}_definitions`"
        class="d-inline"
      >
        <ContentsWithLinks
          :class="definitionClass"
          :content="definition"
          :text-class="definitionClass"
          link-class="article-content__text--link"
        ></ContentsWithLinks>
      </div>
    </template>
    <template v-if="definitionExtensions.length > 0">
      <span v-if="definitions.length > 0">&nbsp;</span>
      <div
        v-for="(definitionExtension, definitionExtensionIndex) in definitionExtensions"
        :key="`${definitionExtensionIndex}_definitionExtensions`"
        class="d-inline"
      >
        <ContentsWithLinks
          :class="definitionClass"
          :content="definitionExtension"
          link-class="article-content__text--link"
        ></ContentsWithLinks>
      </div>
    </template>
  </div>
</template>
